import { KeycloakConfig } from "keycloak-js";

const keycloakConfig:KeycloakConfig = {
  clientId: "EspaceEditeurProClient",
  url: process.env.REACT_APP_KEYCLOAK_URL_BASE_AUTH,
  realm: process.env.REACT_APP_KEYCLOAK_REALM + "",

  //popup_redirect_uri:_KEYCLOAK_URL_BASE_AUTH +''
  // ...
};
export default keycloakConfig;
